require.register("app/restaurant/bookmark/export/ExcelModal", function(exports, require, module){
  $0
  
});

